import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, Unsubscribable } from 'rxjs';
import { CreateContentLikeGQL, DeleteContentLikeGQL } from 'src/app/pages/likes/likes.mutation.generated';
import { CarouselableEntityEnum, ContentLike } from 'src/types/graphql';

@Injectable({ providedIn: 'root' })
export class ContentCardService {
  public favourite$: Observable<{ id: string; __typename: string; myFavourite: Partial<ContentLike> }>;
  private favouriteSubject: BehaviorSubject<{ id: string; __typename: string; myFavourite: Partial<ContentLike> }>;
  private subscriptions: Unsubscribable[] = [];

  constructor(
    private createContentLikeGQL: CreateContentLikeGQL,
    private deleteContentLikeGQL: DeleteContentLikeGQL,
  ) {
    this.favouriteSubject = new BehaviorSubject(null);
    this.favourite$ = this.favouriteSubject.asObservable();
  }

  onFavourite(id: string, __typename: string, myFav: boolean) {
    const observable = myFav
      ? this.createContentLikeGQL
          .mutate({
            input: {
              contentId: id,
              contentType:
                __typename === 'User'
                  ? CarouselableEntityEnum.User
                  : __typename === 'LikeCollection'
                    ? CarouselableEntityEnum.LikeCollection
                    : CarouselableEntityEnum.SharryContent,
            },
          })
          .pipe(map(r => ({ myFavourite: r.data.contentLikeCreate })))
      : this.deleteContentLikeGQL
          .mutate({
            contentId: id,
            contentType:
              __typename === 'User'
                ? CarouselableEntityEnum.User
                : __typename === 'LikeCollection'
                  ? CarouselableEntityEnum.LikeCollection
                  : CarouselableEntityEnum.SharryContent,
          })
          .pipe(map(() => ({ myFavourite: undefined })));
    this.subscriptions.push(
      observable.subscribe({
        next: ({ myFavourite }) => {
          this.favouriteSubject.next({ id, __typename, myFavourite });
        },
      }),
    );
  }

  getFavourite() {
    return this.favouriteSubject.value;
  }
}
